<template lang="pug">
  #facet-list(:class="{ closed: !drawerOpen }")
    epcis-facet(
      :metrics="metrics"
      :selections="selections"
      @change="updateSelections"
    )
    cities-facet(
      :metrics="metrics"
      :selections="selections"
      @change="updateSelections"
    )
    //- thesaurus-facet(
      filter-id="testThesaurus"
      name="Test thesaurus"
      :metrics="metrics"
      :selections="selections"
      @change="updateSelections"
      )
    //- .drawer-handle(@click="drawerOpen = !drawerOpen;")
      i.material-icons list
</template>

<script>
import EpcisFacet from '@/components/facets/EpcisFacet.vue'
import CitiesFacet from '@/components/facets/CitiesFacet.vue'
import ThesaurusFacet from '@/components/facets/ThesaurusFacet.vue'

export default {
  components: {
    EpcisFacet,
    CitiesFacet,
    ThesaurusFacet,
  },
  props: {
    metrics: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selections: [],
      drawerOpen: true,
    };
  },
  methods: {
    updateSelections({ filter, selection }) {
      const oldSelectionIdx = this.selections.findIndex(it => it.filter.id === filter.id);
      const newSelection = { filter, selection };
      if (oldSelectionIdx > -1) {
        if (newSelection.selection.length) {
          this.selections.splice(oldSelectionIdx, 1, newSelection);
        } else {
          this.selections.splice(oldSelectionIdx, 1);
        }
      } else {
        this.selections.push(newSelection);
      }
      this.$emit('change', this.selections);
    },
  },
};
</script>

<style lang="scss">
  #facet-list {
    > div {
      margin: 2em 0;
    }
    transition: transform .4s;
    &.closed {
      transform: translateX(100%);
    }
    .drawer-handle {
      background: var(--primary);
      width: 2em;
      height: 4em;
      border-radius: 2em 0 0 2em;
      position: absolute;
      left: -2em;
      top: calc(50% - 4em);
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        color: white;
        margin-left: 2px;
      }
    }
  }
</style>